module.exports = __webpack_public_path__ + "img/download-app-store.6d23f6ce.png";